import type { LevelDoc } from '../model/format.ts';
import type { NetPlay } from './net.ts';
import { Session } from './view/session.ts';

export interface PlayOptions {
  canvas: HTMLCanvasElement;
  doc: LevelDoc;
  /** optional spawn override (world position) */
  spawn?: [number, number];
  onExit?: () => void;
  /** lobby play. Omit for a local session. */
  net?: NetPlay;
}

export interface PlaySession {
  stop(): void;
}

export function startPlay(opts: PlayOptions): PlaySession {
  const s = new Session(opts);
  return { stop: () => s.stop() };
}
